import { globals } from 'config/globals';
import { Point } from 'utils/math';
import { device } from 'utils/device';

export class TimelineItemRepell {
	private _distance: number; //Distance to mouse from Math helper
	private _moveX: number = 0;
	private _moveY: number = 0;

	private _repellLimit: number = 50;
	private _repellAmountActive: number;
	private _repellAmount: number;
	private _repellAmountIntro: number;
	private _repellAmountButton: number;
	private _active: boolean = true;
	private _center: Point;
	private _repellCenter: Point;

	constructor(sprite: PIXI.Sprite, distanceTolerence: number = 50, easePower: number = 20) {
		1 + Math.random() * 0.7;
		this._repellAmount = 40 + Math.random() * 20;
		this._repellAmountIntro = 60 + Math.random() * 20;
		this._repellAmountButton = 40 + Math.random() * 10;

		this._center = {
			x: device.innerWidth / 2,
			y: device.innerHeight / 2
		};
	}

	public setActive(active: boolean): void {
		this._active = active;
	}

	public get active(): boolean {
		return this._active;
	}

	public retarget(mouseCords: Point, targetCords: Point): Point {
		if (!this._active) {
			return targetCords;
		}

		this._repellCenter = globals.introActive || globals.buttonActive ? this._center : mouseCords;

		this._distance = Math.sqrt(
			Math.pow(targetCords.x - this._repellCenter.x, 2) + Math.pow(targetCords.y - this._repellCenter.y, 2)
		);

		this._repellLimit = globals.introActive ? 75 : 50;
		this._repellAmountActive = globals.introActive ? this._repellAmountIntro : this._repellAmount;

		if (globals.buttonActive) {
			this._repellLimit = 50;
			this._repellAmountActive = this._repellAmountButton;
		}

		if (this._distance < this._repellLimit) {
			let radians = Math.atan2(targetCords.y - this._repellCenter.y, targetCords.x - this._repellCenter.x);
			targetCords.x = this._repellCenter.x + Math.cos(radians) * this._repellAmountActive;
			targetCords.y = this._repellCenter.y + Math.sin(radians) * this._repellAmountActive;
		}

		return targetCords;
	}

	public setParticleRepellCenter(center: Point): void {
		this._center = center;
	}

	public getY(): number {
		return this._moveY;
	}

	public getX(): number {
		return this._moveX;
	}
}
